"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LaunchAbilityHandler = exports.LaunchActorAbilityFactory = exports.LaunchAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class LaunchAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Launch;
        this.__typeName = "Launch";
    }
}
exports.LaunchAbilityArgs = LaunchAbilityArgs;
let LaunchActorAbilityFactory = class LaunchActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Launch", "OneEnemies", 0);
    }
};
LaunchActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Launch")
], LaunchActorAbilityFactory);
exports.LaunchActorAbilityFactory = LaunchActorAbilityFactory;
let LaunchAbilityHandler = class LaunchAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [targetId] = ability.args.target.actorIds;
        container.applyAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "melee",
            attackerId: ability.invokerId,
            targetId,
            toApply: [
                AbilityDamage_1.AbilityDamage.Power("Physical", 80)
            ],
            onHit: (sequence) => {
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId,
                    duration: Duration_1.Duration.Turns(3),
                    effect: new core_1.DarknessEffectArgs()
                });
            }
        });
    }
};
LaunchAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Launch)
], LaunchAbilityHandler);
exports.LaunchAbilityHandler = LaunchAbilityHandler;
